import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import { useCommand } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import ErrorMessage from '~/client/components/ErrorMessage'
import Form from '~/client/components/Form'
import ButtonRow from '~/client/components/ButtonRow'
import AvatarAndNameInputs from '~/client/components/AvatarAndNameInputs'

export default function PrivateProfileEditForm(){
  const {currentUser, mutate} = useCurrentUser()
  const [displayName, setDisplayName] = React.useState(currentUser.displayName)
  const [avatar, setAvatar] = React.useState(currentUser.avatar)
  const reset = () => {
    setDisplayName(currentUser.displayName)
    setAvatar(currentUser.avatar)
  }
  const updateProfile = useCommand('users.updateProfile', {
    onSuccess(newCurrentUser){
      setDisplayName(newCurrentUser.displayName)
      setAvatar(newCurrentUser.avatar)
      mutate(newCurrentUser)
    }
  })
  const disabled = !!updateProfile.pending
  const submittable = (
    displayName !== currentUser.displayName ||
    avatar !== currentUser.avatar
  )
  return (
    <Form {...{
      disabled,
      onSubmit(){
        updateProfile.call({ displayName, avatar })
      },
    }}>
      <ErrorMessage error={updateProfile.error}/>
      <AvatarAndNameInputs {...{
        disabled,
        avatar,
        onAvatarChange: setAvatar,
        displayName,
        onDisplayNameChange: setDisplayName
      }}/>
      <Box>
        <TextField
          label="Email"
          disabled
          margin="normal"
          fullWidth
          type="email"
          readOnly
          value={currentUser.email}
        />
      </Box>
      <ButtonRow>
        <Button
          type="submit"
          variant="contained"
          disabled={disabled || !submittable}
        >Update Profile</Button>
        <Button
          variant="text"
          disabled={disabled}
          onClick={reset}
        >reset</Button>
      </ButtonRow>
    </Form>
  )
}
